import React from "react";

export const ArrowMarkerBlue: React.FC = () => (
    <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="blue" />
    </marker>
);

export const ArrowMarkerGreen: React.FC = () => (
    <marker id="arrowhead-green" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="#22c55e" />
    </marker>
);

export const ArrowMarkerOrange: React.FC = () => (
    <marker id="arrowhead-orange" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="#f97316" />
    </marker>
);

export const SvgArrowDefs: React.FC = () => (
    <defs>
        <ArrowMarkerBlue />
        <ArrowMarkerGreen />
        <ArrowMarkerOrange />
    </defs>
);
